function randomNumGenerator(low, high) {
    return Math.random() * (high - low) + low;
};

export function GetUUID() {
    const UUID = Number(randomNumGenerator(10000, 99999)).toFixed(0) + Number(randomNumGenerator(1000, 9999)).toFixed(0)
    return UUID;
}